import { getContent } from './get-content';
import { parseConfirmationMessage } from './parse-confirmation-message';

export function getEventConfirmation({ checkout, charge, seller, email }) {
  const { title, message } = getContent({ checkout, charge, email });

  const { html, text } = parseConfirmationMessage(message, {
    charge,
    seller,
    checkout,
  });

  return {
    title: charge.livemode ? title : `[TEST] ${title}`,
    message: html || text,
    type: html ? 'html' : 'text',
  };
}
